export default "__VITE_ASSET__ce42e082__"